import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsFor() {
  const forYou = ['Administrativos, Project Managers y profesionales que se sienten "quemados" (burnout).', 'Empleados corporativos que quieren destacar sin sacrificar su salud mental.', 'Personas que usan ChatGPT pero sienten que el resultado sigue siendo mediocre.', 'Cualquiera que prefiera pasar la tarde en el gimnasio o con su familia en lugar de frente a un monitor.'];
  const notForYou = ['Personas que buscan "hacer trampa" sin revisar el resultado final.', 'Programadores senior que ya construyen sus propias herramientas de IA.', 'Gente que cree que el esfuerzo bruto es la única forma de tener éxito.'];
  return <section className="py-24 bg-[#0a0f1a]" data-id="element-196">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-197">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-198">
          {/* For You */}
          <FadeIn direction="left" data-id="element-199">
            <div className="bg-[#111827] border border-green-500/30 rounded-3xl p-8 md:p-10 h-full shadow-[0_0_30px_rgba(34,197,94,0.05)]" data-id="element-200">
              <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-201">
                <span className="bg-green-500/20 text-green-400 p-2 rounded-lg" data-id="element-202">
                  <CheckCircle2 className="w-6 h-6" data-id="element-203" />
                </span>
                ESTO ES PARA TI SI...
              </h3>
              <ul className="space-y-6" data-id="element-204">
                {forYou.map((text, i) => <li key={i} className="flex gap-4 items-start" data-id="element-205">
                    <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-206" />
                    <span className="text-[#d1d5db] text-lg leading-relaxed" data-id="element-207">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Not For You */}
          <FadeIn direction="right" delay={0.2} data-id="element-208">
            <div className="bg-[#111827] border border-red-500/20 rounded-3xl p-8 md:p-10 h-full" data-id="element-209">
              <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-210">
                <span className="bg-red-500/10 text-red-400 p-2 rounded-lg" data-id="element-211">
                  <XCircle className="w-6 h-6" data-id="element-212" />
                </span>
                ESTO NO ES PARA TI SI...
              </h3>
              <ul className="space-y-6" data-id="element-213">
                {notForYou.map((text, i) => <li key={i} className="flex gap-4 items-start" data-id="element-214">
                    <XCircle className="w-6 h-6 text-red-500/70 shrink-0 mt-0.5" data-id="element-215" />
                    <span className="text-slate-400 text-lg leading-relaxed" data-id="element-216">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}